//components
import { PillLink } from '@/containers-ai/Buttons';
import { Grad } from '@/containers-ai/SectionHeading';

//styles
import { EndCTASection, Wrap, Title, Copy } from './EndCTA.styles';

export function EndCTA({ variant = 'top' }) {
  return (
    <EndCTASection
      id={variant === 'top' ? 'cta' : undefined}
      $variant={variant}
    >
      <Wrap>
        <Title>
          Watch it run <Grad>your freight.</Grad>
        </Title>
        <Copy>
          We&rsquo;ll take one workflow, run it end to end, and show you the
          outcome in your own systems.
        </Copy>
        <PillLink
          href="/contact/#contact-form"
          style={{ fontSize: '16px', padding: '16px 32px' }}
        >
          Book a demo &#8594;
        </PillLink>
      </Wrap>
    </EndCTASection>
  );
}
